import * as React from 'react';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import { useTranslation } from '@elevio/kb-kit/lib/hooks';
import * as Search from '@elevio/kb-kit/lib/components/search';
import * as Categories from '@elevio/kb-kit/lib/components/categories';
import PageLayout from '../components/layouts/Page';
import Header from '../components/Header';
import Breadcrumb from '../components/PageBreadcrumbs';
import Footer from '../components/Footer';
import {
  MainSection,
  GridContainer,
  GridItem,
} from '../components/layouts/Main';
import CategoryCard from '../components/CategoryCard';
import * as Meta from '@elevio/kb-kit/lib/components/meta';
import * as Category from '@elevio/kb-kit/lib/components/category';

const HomePage = () => {
  const { t } = useTranslation();
  return (
    <PageLayout header={<Header />} footer={<Footer />}>
      <Breadcrumb />
      <div id="mk-theme-container">
        <div className="add-bs">
          <div className="pr-area extra-padding">
            <div className="container bigger bigger-home">
              {/* <div className="row padded p40 b-98"> */}
              <div className="row">
                <div className="col-lg">
                  <div className="row row-cards">
                    <div className="col-12">
                      <h1 className="page-title">Help Center</h1>
                    </div>
                    <Categories.Loop>
                      <CategoryCard data-testid="category-card" />
                    </Categories.Loop>

                    <a
                      href={'https://help.api.cynet.com/'}
                      className="col-12 col-md-6 col-lg-auto b98"
                    >
                      <div className="pr-box">
                        <img
                          className="desktop-image icon"
                          src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 26.3.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 134.9 153.6' style='enable-background:new 0 0 134.9 153.6;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23F7F7F7;%7D .st1%7Bfill:%23ECEDEC;%7D .st2%7Bfill:%23F9379F;%7D .st3%7Bfill:%23FFFFFF;%7D .st4%7Bclip-path:url(%23SVGID_00000035521622020969614700000009822147609911217040_);%7D .st5%7Bfill:%23F937A0;%7D .st6%7Bfill:%2300CC99;%7D .st7%7Bfill:%23001C2C;%7D .st8%7Bclip-path:url(%23SVGID_00000106837099165052930500000003531142796768360085_);%7D .st9%7Bfill:%23E8E9EA;%7D .st10%7Bclip-path:url(%23SVGID_00000021827370705980453310000014213439834695093132_);%7D .st11%7Bclip-path:url(%23SVGID_00000038399516040869533000000011220963057450357404_);%7D .st12%7Bfill:none;stroke:%23EEECEF;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;%7D .st13%7Bfill:none;stroke:%231E202C;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;%7D .st14%7Bclip-path:url(%23SVGID_00000149365601731303572460000007455017280442344843_);%7D .st15%7Bclip-path:url(%23SVGID_00000098193005348504676760000014943756874692930718_);%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.55;stroke-miterlimit:10;%7D%0A%3C/style%3E%3Cg%3E%3Cline class='st16' x1='67.4' y1='69.5' x2='67.4' y2='88'/%3E%3Cpolyline class='st16' points='27.2,87.5 107.7,87.5 107.7,86.6 107.7,105.1 '/%3E%3Cline class='st16' x1='67.4' y1='86.6' x2='67.4' y2='105.1'/%3E%3Cline class='st16' x1='27.3' y1='86.6' x2='27.3' y2='105.1'/%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath class='st2' d='M39.8,103.5h-6H20.7h-5.6c-0.7,0-1.2,0.6-1.2,1.2v14.6l27.2,0v-14.6C41,104.1,40.5,103.5,39.8,103.5z M39.4,117.1H39v-10.7c0-0.3-0.3-0.6-0.6-0.6H16.5c-0.3,0-0.6,0.3-0.6,0.6v10.7h-0.4v-10.7c0-0.5,0.4-1,1-1h21.9 c0.5,0,1,0.4,1,1V117.1z'/%3E%3Cpath class='st2' d='M31.3,119.5v0.7h-7.7v-0.7H10.1c0,0,1.9,2.3,3.6,2.3h27.5c1.6,0,3.2-2.3,3.2-2.3H31.3z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath class='st2' d='M80,103.5h-6H60.9h-5.6c-0.7,0-1.2,0.6-1.2,1.2v14.6l27.2,0v-14.6C81.3,104.1,80.7,103.5,80,103.5z M79.6,117.1h-0.4v-10.7c0-0.3-0.3-0.6-0.6-0.6H56.7c-0.3,0-0.6,0.3-0.6,0.6v10.7h-0.4v-10.7c0-0.5,0.4-1,1-1h21.9 c0.5,0,1,0.4,1,1V117.1z'/%3E%3Cpath class='st2' d='M71.5,119.5v0.7h-7.7v-0.7H50.4c0,0,1.9,2.3,3.6,2.3h27.5c1.6,0,3.2-2.3,3.2-2.3H71.5z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath class='st2' d='M120.2,103.5h-6h-13.1h-5.6c-0.7,0-1.2,0.6-1.2,1.2v14.6l27.2,0v-14.6C121.5,104.1,120.9,103.5,120.2,103.5 z M119.8,117.1h-0.4v-10.7c0-0.3-0.3-0.6-0.6-0.6H97c-0.3,0-0.6,0.3-0.6,0.6v10.7H96v-10.7c0-0.5,0.4-1,1-1h21.9 c0.5,0,1,0.4,1,1V117.1z'/%3E%3Cpath class='st2' d='M111.7,119.5v0.7H104v-0.7H90.6c0,0,1.9,2.3,3.6,2.3h27.5c1.6,0,3.2-2.3,3.2-2.3H111.7z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Ccircle class='st3' cx='27.4' cy='112.1' r='3.8'/%3E%3Cpath class='st1' d='M25.7,108c0,0-2.1,6.3,5.5,6.1c0,0-5.2,5.1-7.6-0.7C23.6,113.3,22.6,109.6,25.7,108z'/%3E%3Cpath d='M27.4,117c-0.3,0-0.5,0-0.8-0.1c-2.7-0.4-4.5-2.9-4.1-5.6c0.4-2.7,3-4.5,5.6-4.1c1.3,0.2,2.4,0.9,3.2,2 c0.8,1.1,1.1,2.4,0.9,3.7c-0.2,1.3-0.9,2.4-2,3.2C29.4,116.7,28.4,117,27.4,117z M27.3,108.3c-1.8,0-3.4,1.3-3.7,3.2 c-0.3,2.1,1.1,4,3.1,4.3c1,0.2,2-0.1,2.8-0.7c0.8-0.6,1.4-1.5,1.5-2.5l0,0c0.3-2.1-1.1-4-3.1-4.3 C27.7,108.3,27.5,108.3,27.3,108.3z'/%3E%3C/g%3E%3Cg%3E%3Ccircle class='st3' cx='67.5' cy='112.1' r='3.8'/%3E%3Cpath class='st1' d='M65.9,108c0,0-2.1,6.3,5.5,6.1c0,0-4.9,5-7.6-0.7C63.8,113.3,62.8,109.6,65.9,108z'/%3E%3Cpath d='M67.5,117c-0.3,0-0.5,0-0.8-0.1c-2.7-0.4-4.5-2.9-4.1-5.6c0.4-2.7,3-4.5,5.6-4.1c1.3,0.2,2.4,0.9,3.2,2 c0.8,1.1,1.1,2.4,0.9,3.7c-0.2,1.3-0.9,2.4-2,3.2C69.6,116.7,68.6,117,67.5,117z M67.5,108.3c-1.8,0-3.4,1.3-3.7,3.2 c-0.3,2.1,1.1,4,3.1,4.3c1,0.2,2-0.1,2.8-0.7c0.8-0.6,1.4-1.5,1.5-2.5l0,0c0.3-2.1-1.1-4-3.1-4.3 C67.9,108.3,67.7,108.3,67.5,108.3z'/%3E%3C/g%3E%3Cg%3E%3Ccircle class='st3' cx='107.6' cy='112' r='3.8'/%3E%3Cpath class='st1' d='M106,108c0,0-2.1,6.3,5.5,6.1c0,0-4.9,4.9-7.6-0.7C103.9,113.3,102.8,109.6,106,108z'/%3E%3Cpath d='M107.6,117c-0.3,0-0.5,0-0.8-0.1c-2.7-0.4-4.5-2.9-4.1-5.6c0.4-2.7,3-4.5,5.6-4.1c1.3,0.2,2.4,0.9,3.2,2 c0.8,1.1,1.1,2.4,0.9,3.7s-0.9,2.4-2,3.2C109.6,116.7,108.6,117,107.6,117z M107.6,108.3c-1.8,0-3.4,1.3-3.7,3.2 c-0.3,2.1,1.1,4,3.1,4.3c1,0.2,2-0.1,2.8-0.7c0.8-0.6,1.4-1.5,1.5-2.5l0,0c0.3-2.1-1.1-4-3.1-4.3 C108,108.3,107.8,108.3,107.6,108.3z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath class='st2' d='M48.9,49.5c-1.1,0.2-2.1,0.4-3.2,0.7c-0.4,2.4-0.4,4.9,0,7.2c1.8,0.5,3.6,0.8,5.4,1l0.2,0.8 c0.1,0.3,0.2,0.5,0.3,0.8l0.3,0.8l0.4,0.8l-1.1,2.3c-0.6,0.9-1.3,1.8-1.8,2.7c1.4,2,3.1,3.7,5.1,5.2c0.8-0.4,1.6-0.9,2.3-1.4 c0.8-0.5,1.5-1.1,2.2-1.7c0.2,0.1,0.5,0.3,0.8,0.4l0.8,0.4c0.3,0.1,0.5,0.3,0.8,0.4l0.8,0.3l0.9,2.4c0.2,1.1,0.4,2.1,0.7,3.2 c2.4,0.4,4.9,0.4,7.2,0c0.5-1.8,0.8-3.6,1-5.4l0.8-0.2c0.3-0.1,0.5-0.2,0.8-0.3l0.8-0.3l0.8-0.4l2.3,1.1 c0.9,0.6,1.8,1.3,2.7,1.8c2-1.4,3.7-3.1,5.2-5.1c-0.4-0.8-0.9-1.6-1.4-2.3c-0.5-0.8-1.1-1.5-1.7-2.2c0.1-0.2,0.3-0.5,0.4-0.8 l0.4-0.8c0.1-0.3,0.3-0.5,0.4-0.8l0.3-0.8l2.4-0.9c1.1-0.2,2.1-0.4,3.2-0.7c0.4-2.4,0.4-4.9,0-7.2c-1.8-0.5-3.6-0.8-5.4-1 l-0.2-0.8c-0.1-0.3-0.2-0.5-0.3-0.8L83.1,47l-0.4-0.8l1.1-2.3c0.6-0.9,1.3-1.8,1.8-2.7c-1.4-2-3.1-3.7-5.1-5.2 c-0.8,0.4-1.6,0.9-2.3,1.4c-0.8,0.5-1.5,1.1-2.2,1.7c-0.2-0.1-0.5-0.3-0.8-0.4l-0.8-0.4c-0.3-0.1-0.5-0.3-0.8-0.4l-0.8-0.3 l-0.9-2.4c-0.2-1.1-0.4-2.1-0.7-3.2c-2.4-0.4-4.9-0.4-7.2,0c-0.5,1.8-0.8,3.6-1,5.4l-0.8,0.2c-0.3,0.1-0.5,0.2-0.8,0.3l-0.8,0.3 l-0.8,0.4l-2.3-1.1c-0.9-0.6-1.8-1.3-2.7-1.8c-2,1.4-3.7,3.1-5.2,5.1c0.4,0.8,0.9,1.6,1.4,2.3c0.5,0.8,1.1,1.5,1.7,2.2 c-0.1,0.2-0.3,0.5-0.4,0.8L51.9,47c-0.1,0.3-0.3,0.5-0.4,0.8l-0.3,0.8L48.9,49.5z'/%3E%3C/g%3E%3Ccircle class='st3' cx='67.5' cy='53.9' r='7.2'/%3E%3C/g%3E%3Cpath class='st9' d='M72.5,59.1c-2.9,2.8-7.4,2.7-10.2-0.1c-2.8-2.9-2.7-7.4,0.1-10.2l0.5,1.8C64.3,55,68,58.3,72.5,59.1 L72.5,59.1z'/%3E%3C/g%3E%3Cline class='st16' x1='27.3' y1='103.5' x2='27.3' y2='107.5'/%3E%3Cline class='st16' x1='67.4' y1='103.5' x2='67.4' y2='107.5'/%3E%3Cline class='st16' x1='107.7' y1='103.5' x2='107.7' y2='107.5'/%3E%3C/g%3E%3C/svg%3E%0A"
                        />

                        <h4>API Reference</h4>
                        <p className="pr-box__description">
                          Discover what you can do with the Cynet API
                        </p>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-auto">
                  <div className="widget-usefull-links">
                    <h2>Useful Links</h2>

                    <ul className="widget-usefull-links__list">
                      <li>
                        <a
                          href="https://cynet.my.site.com/Community/s/login/"
                          className="li-inner"
                        >
                          <span className="icon">
                            <img
                              width="29"
                              height="28"
                              src="https://www.cynet.com/wp-content/uploads/2023/07/community-icon.svg"
                              alt="Community icon"
                            />
                          </span>
                          <div className="col px-0">
                            <h3>Community</h3>
                            <p>Case management and knowledge base</p>
                          </div>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://cynet.statuspage.io/"
                          className="li-inner"
                        >
                          <span className="icon">
                            <img
                              width="28"
                              height="26"
                              src="https://www.cynet.com/wp-content/uploads/2023/07/status-page-icon.svg"
                              alt="Status page icon"
                            />
                          </span>
                          <div className="col px-0">
                            <h3>Status Page</h3>
                            <p>
                              Current health status of the cloud application
                            </p>
                          </div>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://portal.cynet.com/English/"
                          className="li-inner"
                        >
                          <span className="icon">
                            <img
                              width="32"
                              height="35"
                              src="https://www.cynet.com/wp-content/uploads/2023/07/partner-portal-icon.svg"
                              alt="Parent Portal icon"
                            />
                          </span>
                          <div className="col px-0">
                            <h3>Partner Portal</h3>
                            <p>Training and resources for partners</p>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

const HomePageOld = () => {
  const { t } = useTranslation();
  return (
    <PageLayout
      header={
        <Header hideSearch>
          <h1>
            <Trans i18nKey="home.welcome">
              Welcome to the elevio help center. <br />
              Here you will find documentation on how to use our product.
            </Trans>
          </h1>
          <Search.Input
            placeholder={t('search.placeholder', 'Search our help center...')}
            data-testid="search-input"
            className="hero-search"
            style={{ cursor: 'default' }}
          />
        </Header>
      }
      footer={<Footer />}
    >
      <MainSection>
        <GridContainer>
          <Categories.Loop>
            <GridItem>
              <CategoryCard data-testid="category-card" />
            </GridItem>
          </Categories.Loop>
        </GridContainer>
      </MainSection>
    </PageLayout>
  );
};

export default HomePage;
